export class OrderSummary {
  public tests: string[];
  public payments: string[];
  public total: number;

  public constructor(tests: string[], payments: string[], total: number) {
    this.tests = tests;
    this.payments = payments;
    this.total = total;
  }
}
